"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StepsBannerBullets = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StepsBanner = require("./StepsBanner");
var _uiElementPropTypes = require("../../../propTypes/uiElementPropTypes");
require("./stepsBannerBullets.scss");
const _excluded = ["steps", "customCssClass"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const StepsBannerBullets = _ref => {
  let {
      steps,
      customCssClass
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!steps || !steps.length) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_StepsBanner.StepsBanner, _extends({
    steps: steps || [],
    bannerStyle: "bullets",
    customCssClass: customCssClass
  }, otherProps));
};
exports.StepsBannerBullets = StepsBannerBullets;
StepsBannerBullets.propTypes = _uiElementPropTypes.StepsBannerPropType;
var _default = exports.default = StepsBannerBullets;